export default "__VITE_PUBLIC_ASSET__2489b91a__"